import { render, staticRenderFns } from "./infoAllData.vue?vue&type=template&id=f8d2c73c&scoped=true"
import script from "./infoAllData.vue?vue&type=script&lang=js"
export * from "./infoAllData.vue?vue&type=script&lang=js"
import style0 from "./infoAllData.vue?vue&type=style&index=0&id=f8d2c73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d2c73c",
  null
  
)

export default component.exports